import React, { useState } from 'react'
import { Row, Col } from 'antd'
import './add-area.less';
import AreaForm from './areaForm';
import ListArea from './list'
import { useSelector } from 'react-redux'
export default function AddArea() {
    const [addedArea, setAddedArea] = useState();
    const langValue = useSelector(state => state.langList.value)
    const addSuccess = (data) => {
        // console.log('add success:', data);
        const { province, city, areaCode, areaName } = data;
        let obj = { '地区（省）': province, '地区（市）': city, '编号': areaCode, '名称': areaName, '状态': 'on' };
        setAddedArea(obj);
    }
    return (
        <div className="set-area">
            <Row>
                {/* 左边新建地区组件 */}
                <Col xs={10} sm={10} md={10} lg={10} xl={8} style={{ backgroundColor: "#fff", paddingLeft: 24, paddingTop: 12, paddingBottom: 12 }} key="left">
                    <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#0c145a' }}><div style={{ borderLeft: '4px solid #0c145a', paddingRight: 10 }} />{langValue==0?'新建地区Create a new region':(langValue==1?'新建地区':'Create a new region')}</h1>
                    <AreaForm handleSuccess={addSuccess} />
                </Col>
                {/* 右边地区列表 */}
                <Col xs={10} sm={10} md={10} lg={10} xl={16} style={{ backgroundColor: "white", border: '1px solid #eee' }} key="right">
                    <ListArea {...{ addedArea }} />
                </Col>
            </Row>


        </div >
    )
}
